import React from 'react';
import {TariffsState} from 'components/ui/tariffs-state/TariffsState';

const TariffsParameter = ({parameter, states, index}) => {
  return (
    <tr>
      <td
        className="tariffs__parameter"
        style={{gridRowStart: index + 2, gridColumnStart: 1}}
      >
        <span>{parameter}</span>
      </td>

      {states.map((state, i) => (
        <TariffsState
          key={i}
          checked={state}
          className={`tariffs__state ${i === 0 ? 'tariffs__state--first' : ''}`}
          style={{gridRowStart: index + 2, gridColumnStart: i + 2}}
        />
      ))}
    </tr>
  );
};

export default TariffsParameter;
